export const PublicIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="18"
    viewBox="0 0 12 16"
    fill="none"
  >
    <path
      d="M1 14.5V1H11V14.5L6 9.5L1 14.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)
